import { Box, Typography } from "@mui/material";

const PlanDetailsProBundle = () => {
  return (
    <Box sx={{ my: 2 }}>
      {" "}
      <Typography variant="h2" textAlign="center" component="div">
        <strong>
          Pro{" "}
          <Box
            component="span"
            sx={{ color: "green.light", fontSize: 30, opacity: 0.5 }}
          >
            &
          </Box>{" "}
          Partnership Data
        </strong>
      </Typography>
      <Typography sx={{ my: 3 }}>
        Get 1,000 verified brand emails every month, exclusive brand and contact
        data, and priority access to our new Instagram tagging feature.
      </Typography>
      <strong>Monthly Plan</strong>
    </Box>
  );
};

export default PlanDetailsProBundle;
